import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import getResponsiveImage from 'app/utils/getResponsiveImage';

import Selectors from 'app/redux/ui/heroCta/selectors';

import Button from 'app/components/Button';

import styles from './styles.css';

class HeroCta extends PureComponent {
  render() {
    const { image, onCtaClick, title, viewport } = this.props;
    const imageSrc = getResponsiveImage(image, viewport);

    return (
      <div className={styles.container}>
        <div className={styles.grid}>
          <h2 className={styles.title}>{title}</h2>
          <Button
            onClick={onCtaClick}
            label={'Take the survey'}
            passedStyles={styles.button}
          />
        </div>

        <img src={imageSrc} alt={title} className={styles.image} />
      </div>
    );
  }
}

export default connect(Selectors)(HeroCta);



// WEBPACK FOOTER //
// ./src/components/HeroCta/index.js